import * as React from 'react'
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import Searchbar from '../../components/Searchbar';
import { API } from '../../api/endpoints/company';
import ClipLoader from 'react-spinners/ClipLoader';
import { CompanyEvent } from '../../api/models/companyEvent';

export interface EventsProps extends RouteComponentProps {

}

export default withRouter(class Events extends React.Component<EventsProps, {
    events?: CompanyEvent[]
    loading: boolean,
    page: number,
    count?: number
}> {


    constructor(props: EventsProps) {
        super(props);
        this.state = {
            loading: true,
            page: 1
        }
    }

    private limit: number = 12

    componentDidMount() {
        this.getEvents()
    }

    getEvents() {
        API.getCompanyEvents().then((events) => {
            this.setState({ events, loading: false })
        }).catch((err) => {
            this.setState({ loading: false })
        })
    }

    countEvents() {
        //ToDo
    }

    render() {

        return (
            <>
                <Searchbar
                    buttons={[
                        {
                            title: "Events anlegen",
                            onClick: () => { this.props.history.push("/add-events") }
                        }
                    ]}
                />
                <div className="main">

                    {this.state.loading ?
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                            <ClipLoader />
                        </div>
                        :
                        this.state.events ?
                            this.state.events.length > 0 ?
                                <div className="row">
                                    {this.state.events.map((events) => {
                                        return this.renderEvents(events)
                                    })}
                                </div>
                                :
                                <div>No Events yet</div>
                            :
                            <div>Cannot load Events</div>
                    }

                </div>
                {!this.state.loading && Boolean(this.state.events) && this.state.count && this.state.count > this.limit && <div className="paging">
                    {this.renderPages()}
                </div>}
            </>
        )
    }


    renderEvents(event: CompanyEvent) {
        return (
            <div className="col-sm-6 col-md-4 col-xl-3" key={`event_${event.id}`}>
                <div className="newscard">
                    <h6>{event.name}</h6>
                    <img src={event.img_url} />
                    <div className="text">
                        <span>{event.description}</span>
                    </div>
                    <div className="text">
                        <span>{event.url}</span>
                    </div>
                    <div className="edit_delete">
                        <Link to={`/edit-company-event?eventId=${event.id}`}>
                            <i className="fa fa-edit"></i>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

    renderPages() {
        if (this.state.count) {
            return (
                <>
                    {this.state.page > 2 && <i className="fa fa-angle-double-left" onClick={() => this.changePage(1)}></i>}
                    {this.state.page > 1 && <i className="fa fa-angle-left" onClick={() => this.changePage(this.state.page - 1)}></i>}
                    {this.state.page - 1 > 0 && <span style={{ cursor: 'pointer' }} onClick={() => this.changePage(this.state.page - 1)}>{this.state.page - 1}</span>}
                    <span className="active">{this.state.page}</span>
                    {this.state.page + 1 <= Math.ceil(this.state.count / this.limit) && <span style={{ cursor: 'pointer' }} onClick={() => this.changePage(this.state.page + 1)}>{this.state.page + 1}</span>}
                    {this.state.page + 2 < Math.ceil(this.state.count / this.limit) && <span>{'...'}</span>}
                    {this.state.page + 1 < Math.ceil(this.state.count / this.limit) && <span style={{ cursor: 'pointer' }} onClick={() => this.changePage(Math.ceil(this.state.count! / this.limit))}>{Math.ceil(this.state.count / this.limit)}</span>}
                    {this.state.page < Math.ceil(this.state.count / this.limit) && <i className="fa fa-angle-right" onClick={() => this.changePage(this.state.page + 1)}></i>}
                    {this.state.page + 1 < Math.ceil(this.state.count / this.limit) && <i className="fa fa-angle-double-right" onClick={() => this.changePage(Math.ceil(this.state.count! / this.limit))}></i>}
                </>
            )
        }
        return
    }

    changePage(page: number) {
        this.setState({page, loading: true}, () => {
            this.getEvents()
        })
    }
})